import { render, staticRenderFns } from "./RcsBubble.vue?vue&type=template&id=966b4e30&scoped=true"
import script from "./RcsBubble.vue?vue&type=script&lang=js"
export * from "./RcsBubble.vue?vue&type=script&lang=js"
import style0 from "./RcsBubble.vue?vue&type=style&index=0&id=966b4e30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966b4e30",
  null
  
)

export default component.exports